module.exports = __webpack_public_path__ + "static/media/kehilangan.4f4d124a.png";